export default __webpack_public_path__ + "static/media/D-Magaya.644f4441.jpg";